export default Object.freeze({
  DISABLED: 'disabled',
  LAZY: 'lazy',
  EAGER: 'eager'
});